import { createIntegration } from '..';

const multiIntegration = (integrations, catchErrors = true) => {
    const integrationIds = Object.keys(integrations);
    return createIntegration({
        name: 'multi-integration',
        async initialize(getSession) {
            await Promise.all(integrationIds.map((id) => {
                return integrations[id].initialize(getSession).catch((e) => {
                    if (!catchErrors) {
                        throw e;
                    }
                    console.error(`Error initializing integration ${id}`, e);
                });
            }));
        },
        async destroy() {
            await Promise.all(integrationIds.map((id) => {
                integrations[id].destroy().catch((e) => {
                    if (!catchErrors) {
                        throw e;
                    }
                    console.error(`Error destroying integration ${id}`, e);
                });
            }));
        },
        getMethods(state, integrationId) {
            const ids = integrationId ? [integrationId] : integrationIds;
            const promises = ids.map((integrationId) => {
                return integrations[integrationId].getMethods(state).catch((e) => {
                    if (!catchErrors) {
                        throw e;
                    }
                    console.error(`Error getting methods from ${integrationId}`, e);
                    return [];
                });
            });
            return Promise.all(promises).then((results) => {
                return results.reduce((acc, result) => {
                    return acc.concat(result);
                }, []);
            });
        },
        getHostedField(request) {
            const integration = integrations[request.integrationId];
            if (!integration) {
                throw new Error(`Integration ${request.integrationId} not found`);
            }
            if (!integration.getHostedField) {
                throw new Error(`Integration ${request.integrationId} does not support hosted fields`);
            }
            return integration.getHostedField(request);
        },
        getCustomField(request) {
            const integration = integrations[request.integrationId];
            if (!integration) {
                throw new Error(`Integration ${request.integrationId} not found`);
            }
            if (!integration.getCustomField) {
                throw new Error(`Integration ${request.integrationId} does not support custom fields`);
            }
            return integration.getCustomField(request);
        },
        getSavedAccounts(state) {
            const promises = integrationIds.map((integrationId) => {
                return integrations[integrationId].getSavedAccounts(state).catch((e) => {
                    if (!catchErrors) {
                        throw e;
                    }
                    console.error(`Error getting methods from ${integrationId}`, e);
                    return [];
                });
            });
            return Promise.all(promises).then((results) => {
                return results.reduce((acc, result) => {
                    return acc.concat(result);
                }, []);
            });
        },
        getPendingWithdrawals(state) {
            return;
        },
        getMethodDetailsForm(state) {
            const integration = integrations[state.integrationId];
            if (!integration) {
                throw new Error(`Integration ${state.integrationId} not found`);
            }
            return integration.getMethodDetailsForm(state);
        },
        cancelWithdrawal(state) {
            const integration = integrations[state.integrationId];
            if (!integration) {
                throw new Error(`Integration ${state.integrationId} not found`);
            }
            return integration.cancelWithdrawal(state);
        },
        processPayment(state) {
            const integration = integrations[state.integrationId];
            if (!integration) {
                throw new Error(`Integration ${state.integrationId} not found`);
            }
            return integration.processPayment(state);
        },
    });
};

export { multiIntegration };
